import { render, staticRenderFns } from "./AddEditBlogModal.vue?vue&type=template&id=2672cea5&scoped=true&"
import script from "./AddEditBlogModal.vue?vue&type=script&lang=js&"
export * from "./AddEditBlogModal.vue?vue&type=script&lang=js&"
import style0 from "./AddEditBlogModal.vue?vue&type=style&index=0&id=2672cea5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672cea5",
  null
  
)

export default component.exports